import React, { useLayoutEffect, useMemo, useState } from "react";
import { gsap } from "gsap";
const useCases = [
  {
    id: 1,
    name: "Product",
    types: [
      {
        subId: 1,
        tName: "User Segmentation",
        content: {
          heading: "User Segmentation",
          subheading:
            "User segmentation can help you better understand your customers and meet their unique needs.",
          points: [
            "Improving your customer service",
            "Understand your most valuable customers.",
            "Find new opportunities for products & support.",
          ],
          image: require("../../assets/images/product_use_case_1.svg"),
          link: "https://blog.hubspot.com/service/customer-segmentation",
        },
      },
      {
        subId: 2,
        tName: "Track Adoption",
        content: {
          heading: "Track Adoption",
          subheading:
            "Are you sure you are measuring your Product Adoption rate the right way?",
          points: [
            "Understand how to calculate it.",
            "Factor in the role of activation",
            "Understand ways to improve adoption.",
          ],
          image: require("../../assets/images/product_use_case_2.svg"),
          link: "https://www.apty.io/blog/product-adoption-rate",
        },
      },
      {
        subId: 3,
        tName: "Analyze Product Funnel",
        content: {
          heading: "Analyze Product Funnel",
          subheading:
            "A product funnel is a component of an overall sales funnel along with the marketing funnel",
          points: [
            "Understand different parts of the funnel.",
            "Learn to track each part of the funnel.",
            "Increase retention for your product.",
          ],
          image: require("../../assets/images/product_use_case_3.svg"),
          link: "https://specialsaucebranding.com/productize-your-service/",
        },
      },
      {
        subId: 4,
        tName: "Evaluate User Experience",
        content: {
          heading: "Evaluate User Experience",
          subheading:
            "It is critical to ensure your website and product are working effectively to grow your business.",
          points: [
            "Ensure your prospects understand your offer.",
            "Increase your leads/conversion rates.",
            "Reduce bounce rates and churn.",
          ],
          image: require("../../assets/images/product_use_case_4.svg"),
          link: "https://www.forbes.com/sites/theyec/2020/01/03/how-to-evaluate-your-user-experience-ux-to-grow-your-business/?sh=3507fe912fe3",
        },
      },
    ],
  },
  {
    id: 2,
    name: "Marketing",
    types: [
      {
        subId: 1,
        tName: "Personalized Campaigns",
        content: {
          heading: "Personalized Campaigns",
          subheading:
            "Deliver individualized content to your users and customer for better engagement.",
          points: [
            "Increase brand loyalty.",
            "Create a single customer view.",
            "Understand customer preferences.",
          ],
          image: require("../../assets/images/marketing_use_case_1.svg"),
          link: "https://emarsys.com/learn/blog/what-is-personalized-marketing/",
        },
      },
      {
        subId: 2,
        tName: "Ad campaign KPIs",
        content: {
          heading: "Ad campaign KPIs",
          subheading:
            "Double down on Ads that are working for you and improve your Ads.",
          points: [
            "Track total Ad spend across channels.",
            "Track cost per conversion.",
            "Lower your customer acquisition cost.",
          ],
          image: require("../../assets/images/marketing_use_case_2.svg"),
          link: "https://databox.com/most-important-advertising-kpis",
        },
      },
      {
        subId: 3,
        tName: "Maximize Marketing RoI",
        content: {
          heading: "Maximize Marketing RoI",
          subheading:
            "Understand your Marketing RoI by attributing profit and revenue growth.",
          points: [
            "Justify marketing spend.",
            "Distribute marketing budgets.",
            "Build attribution models.",
          ],
          image: require("../../assets/images/marketing_use_case_3.svg"),
          link: "https://www.marketingevolution.com/marketing-essentials/marketing-roi",
        },
      },
      {
        subId: 4,
        tName: "New Customer Acquisition",
        content: {
          heading: "New Customer Acquisition",
          subheading:
            "Learn how to acquire new customers and leverage your current ones to grow your business.",
          points: [
            "Compare acquisition channels.",
            "Optimize customer acquisition cost.",
            "Build a sustainable acquisition strategy.",
          ],
          image: require("../../assets/images/marketing_use_case_4.svg"),
          link: "https://blog.hubspot.com/service/customer-acquisition",
        },
      },
    ],
  },
  {
    id: 4,
    name: "Revenue Ops",
    types: [
      {
        subId: 1,
        tName: "Track Key KPIs",
        content: {
          heading: "Track Key KPIs",
          subheading:
            "The key goal of revenue operations is to drive revenue growth i.e. predictable streams of revenue.",
          points: [
            "Track annual recurring revenue.",
            "Sales Cycle Time.",
            "Track renewals and upsells.",
          ],
          image: require("../../assets/images/revenue_ops_use_case_1.svg"),
          link: "https://www.smartkarrot.com/resources/blog/revenue-operations-revops/",
        },
      },
      {
        subId: 2,
        tName: "Empower Customer Success",
        content: {
          heading: "Empower Customer Success",
          subheading:
            "Help customer success teams to understand customer expectations.",
          points: [
            "Help the team be proactive.",
            "Measure the onboarding the experience.",
            "Improve customer experience.",
          ],
          image: require("../../assets/images/revenue_ops_use_case_2.svg"),
          link: "https://www.smartkarrot.com/resources/blog/revenue-operations-revops/",
        },
      },
      {
        subId: 3,
        tName: "Plan Budget",
        content: {
          heading: "Plan Budget",
          subheading:
            "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
          points: [
            "Upgrade your personal experience instantly.",
            "Retain more, happier customers.",
            "Start with, in an incremental manner.",
          ],
          image: require("../../assets/images/revenue_ops_use_case_3.svg"),
          link: "http://google.com",
        },
      },
      {
        subId: 4,
        tName: "Track Revenue Churn",
        content: {
          heading: "Track Revenue Churn",
          subheading:
            "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
          points: [
            "Upgrade your personal experience instantly.",
            "Retain more, happier customers.",
            "Start with, in an incremental manner.",
          ],
          image: require("../../assets/images/revenue_ops_use_case_4.svg"),
          link: "http://google.com",
        },
      },
    ],
  },
  {
    id: 5,
    name: "Data Analyst",
    types: [
      {
        subId: 1,
        tName: "Centralize Data Modeling",
        content: {
          heading: "Centralize Data Modeling",
          subheading:
            "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
          points: [
            "Upgrade your personal experience instantly.",
            "Retain more, happier customers.",
            "Start with, in an incremental manner.",
          ],
          image: require("../../assets/images/data_analyst_use_case_1.svg"),
          link: "http://google.com",
        },
      },
      {
        subId: 2,
        tName: "Model Churn",
        content: {
          heading: "Model Churn",
          subheading:
            "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
          points: [
            "Upgrade your personal experience instantly.",
            "Retain more, happier customers.",
            "Start with, in an incremental manner.",
          ],
          image: require("../../assets/images/data_analyst_use_case_2.svg"),
          link: "http://google.com",
        },
      },
      {
        subId: 3,
        tName: "Track LTV",
        content: {
          heading: "Track LTV",
          subheading:
            "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
          points: [
            "Upgrade your personal experience instantly.",
            "Retain more, happier customers.",
            "Start with, in an incremental manner.",
          ],
          image: require("../../assets/images/data_analyst_use_case_3.svg"),
          link: "http://google.com",
        },
      },
      {
        subId: 4,
        tName: "Automate Reporting",
        content: {
          heading: "Automate Reporting",
          subheading:
            "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
          points: [
            "Upgrade your personal experience instantly.",
            "Retain more, happier customers.",
            "Start with, in an incremental manner.",
          ],
          image: require("../../assets/images/data_analyst_use_case_4.svg"),
          link: "http://google.com",
        },
      },
    ],
  },
  // {
  //   id: 6,
  //   name: "Customer Success",
  //   types: [
  //     {
  //       subId: 1,
  //       tName: "Beat Fraud",
  //       content: {
  //         heading: "Beat Fraud",
  //         subheading:
  //           "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
  //         points: [
  //           "Upgrade your personal experience instantly.",
  //           "Retain more, happier customers.",
  //           "Start with done for you account setup.",
  //         ],
  //         image: require("../../assets/images/use_case.svg"),
  //       },
  //     },
  //     {
  //       subId: 2,
  //       tName: "my content",
  //       content: {
  //         heading: "my content",
  //         subheading:
  //           "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
  //         points: [
  //           "Upgrade your personal experience instantly.",
  //           "Retain more, happier customers.",
  //           "Start with done for you account setup.",
  //         ],
  //       },
  //     },
  //   ],
  // },
  {
    id: 7,
    name: "Operations",
    types: [
      {
        subId: 1,
        tName: "Forecast Revenue & Costs",
        content: {
          heading: "Forecast Revenue & Costs",
          subheading:
            "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
          points: [
            "Upgrade your personal experience instantly.",
            "Retain more, happier customers.",
            "Start with, in an incremental manner.",
          ],
          image: require("../../assets/images/operations_use_case_1.svg"),
          link: "http://google.com",
        },
      },
      {
        subId: 2,
        tName: "Track Inventory",
        content: {
          heading: "Track Inventory",
          subheading:
            "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
          points: [
            "Upgrade your personal experience instantly.",
            "Retain more, happier customers.",
            "Start with, in an incremental manner.",
          ],
          image: require("../../assets/images/operations_use_case_2.svg"),
          link: "http://google.com",
        },
      },
      {
        subId: 3,
        tName: "Track Partner KPIs",
        content: {
          heading: "Track Partner KPIs",
          subheading:
            "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
          points: [
            "Upgrade your personal experience instantly.",
            "Retain more, happier customers.",
            "Start with, in an incremental manner.",
          ],
          image: require("../../assets/images/operations_use_case_3.svg"),
          link: "http://google.com",
        },
      },
      {
        subId: 4,
        tName: "Monitor Quality",
        content: {
          heading: "Monitor Quality",
          subheading:
            "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
          points: [
            "Upgrade your personal experience instantly.",
            "Retain more, happier customers.",
            "Start with, in an incremental manner.",
          ],
          image: require("../../assets/images/operations_use_case_4.svg"),
          link: "http://google.com",
        },
      },
    ],
  },
  {
    id: 8,
    name: "Finance",
    types: [
      {
        subId: 1,
        tName: "Reconcile Cash",
        content: {
          heading: "Reconcile Cash",
          subheading:
            "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
          points: [
            "Upgrade your personal experience instantly.",
            "Retain more, happier customers.",
            "Start with, in an incremental manner.",
          ],
          image: require("../../assets/images/finance_use_case_1.svg"),
          link: "http://google.com",
        },
      },
      {
        subId: 2,
        tName: "Track Cash Flow",
        content: {
          heading: "Track Cash Flow",
          subheading:
            "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
          points: [
            "Upgrade your personal experience instantly.",
            "Retain more, happier customers.",
            "Start with, in an incremental manner.",
          ],
          image: require("../../assets/images/finance_use_case_2.svg"),
          link: "http://google.com",
        },
      },
      {
        subId: 3,
        tName: "Forecast Revenue & Costs",
        content: {
          heading: "Forecast Revenue & Costs",
          subheading:
            "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
          points: [
            "Upgrade your personal experience instantly.",
            "Retain more, happier customers.",
            "Start with, in an incremental manner.",
          ],
          image: require("../../assets/images/finance_use_case_3.svg"),
          link: "http://google.com",
        },
      },
      {
        subId: 4,
        tName: "Automate Reporting",
        content: {
          heading: "Automate Reporting",
          subheading:
            "Fraud is a deliberate act (or failure to act) with the intention of obtaining an unauthorized benefit, either for oneself or for institution.",
          points: [
            "Upgrade your personal experience instantly.",
            "Retain more, happier customers.",
            "Start with, in an incremental manner.",
          ],
          image: require("../../assets/images/finance_use_case_4.svg"),
          link: "http://google.com",
        },
      },
    ],
  },
];

const HomeCase = () => {
  const [selected, setSelected] = useState(1);
  const [subSelected, setSubSelected] = useState(1);
  const { types } = useMemo(
    () => useCases.filter((u_case) => u_case.id === selected)[0],
    [selected]
  );

  const { content } = useMemo(
    () => types.filter((type) => type.subId === subSelected)[0],
    [subSelected, types]
  );

  useLayoutEffect(() => {
    gsap.fromTo(".subtype-box", { opacity: 0 }, { opacity: 1 });
  }, [selected]);

  useLayoutEffect(() => {
    gsap.fromTo(".huse__content", { opacity: 0 }, { opacity: 1 });
  }, [subSelected, selected]);

  return (
    <div className="home__use">
      <div className="container">
        <div className="huse__heading text__heading ta-c reveal-from-top">
          Everyone benefits from easier access to data
        </div>
        <div className="htiles__container">
          {useCases.map((u_case) => {
            return (
              <div
                className={`tile  ${selected === u_case.id ? "selected" : ""}`}
                onClick={() => {
                  setSelected(u_case.id);
                  setSubSelected(1);
                }}
                key={u_case.id}
              >
                {u_case.name}
              </div>
            );
          })}
        </div>
        <div className="bottom">
          <div className="left use__left">
            <div className="subtype-heading ta-c">Use Cases</div>
            <div className="subtype-box">
              {types.map((type, index) => {
                return (
                  <div
                    className={`type__tile ${
                      type.subId === subSelected ? "selected" : ""
                    }`}
                    onClick={() => setSubSelected(type.subId)}
                    key={index}
                  >
                    {type.tName}
                  </div>
                );
              })}
            </div>
          </div>
          <div className="right huse__content">
            <div className="use__content-left">
              <div className="heading">{content?.heading}</div>
              <div className="subHeading">{content?.subheading}</div>
              <div className="point__box">
                {content?.points.map((point, index) => {
                  return (
                    <div className="point" key={index}>
                      <img
                        src={require("../../assets/images/check.svg")}
                        alt="check"
                      />{" "}
                      {point}
                    </div>
                  );
                })}
              </div>
              <a href={content?.link} target="_blank" rel="noopener noreferrer">
                <button className="button__main button__tertiary">
                  Read More{" "}
                  <img
                    src={require("../../assets/images/long-arrow-right.svg")}
                    alt="arrow"
                  />
                </button>
              </a>
            </div>
            <div className="use__content-right">
              <img src={content?.image} alt="im" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeCase;
